@let notification = notificationData();

<fcom-notification
  class="wrap"
  data-testid="overlapping-services-notification"
  [theme]="notification.theme"
  [iconName]="notification.icon"
  [linkText]="notification.ctaTextKey | finLocalization: { category: notification.ctaCategoryKey | finLocalization }"
  [secondaryLinkText]="'ancillaries.overlappingServicesNotification.keepSelection' | finLocalization"
  (linkClick)="continueToSelection(notification.overlapSeat?.seatNumber)"
  (secondaryLinkClick)="cancelSelection.emit()"
>
  {{
    notification.messageKey
      | finLocalization
        : {
            currentCategory: currentCategoryKey() | finLocalization,
            overlapCategory: notification.singleOverlapService.categoryKey | finLocalization,
          }
  }}

  @if (notification.overlapCount > 1) {
    <ul class="ms-large-l" data-testid="overlapping-services-list">
      @for (service of notification.overlappingServices; track service.id) {
        <li data-testid="overlapping-service-list-item">{{ service.displayName }}</li>
      }
    </ul>
  }
</fcom-notification>
